import { apiFetch } from '~/utils/apiFetch'
import type { BootstrapDto } from '~/types/api/bootstrap'

/**
 * GET /api/v1/bootstrap — 公开配置聚合（站点时区、fx 牌价等）；无需登录。
 * 保持无参，才能直接当作 vue-query 的 queryFn。后台配置请求不挡全屏 loading。
 */
export function fetchBootstrap() {
  return apiFetch<BootstrapDto>('/bootstrap', {
    skipAuth: true,
    skipErrorToast: true,
    skipGlobalLoading: true,
  })
}
